import React, {useEffect, useRef, useState} from "react";

import Icon from '../atoms/Icon'
import log from "../adminPage/Log";
import {useSearchParams} from "react-router-dom";

const TableSearchBox = ({placeholder, onSearchBtnClick, onCancelSearchClick, isCancelVisible}) => {
    const [searchParams, setSearchParams] = useSearchParams();

    const [inputValue, setInputValue] = useState("")
    const [cancelIsShow, setCancelIsShow] = useState(false)
    const inputRef = useRef(null);
    const changeInputValue = (event) => {
        setInputValue(event.target.value)
    }
    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            onSearchBtnClick(inputValue);
        }
    };
    useEffect(() => {

        if (inputValue.length===0){
            setCancelIsShow(false)
        }else{

            setCancelIsShow(true)
        }
    }, [inputValue]);

    useEffect(() => {
        const params = new URLSearchParams(searchParams);
        if (params.has("search")){
            inputRef.current.value = params.get("search")
            setInputValue(params.get("search"))
        }
    }, []);
    const onCancelBtnClick = (event) => {
        setCancelIsShow(false)
        setInputValue("")
        inputRef.current.value = ""
        onSearchBtnClick("");
    }
    return (
        <div className={"felx items-center"}>

            <label htmlFor="simple-search" className="sr-only">
                Search
            </label>
            <div className="relative w-350 flex flex-row border-gray border-2 rounded-sm justify-between h-10">
                <div className="absolute inset-y-0 right-5 flex items-center pl-3 pointer-events-none">
                    <Icon iconName='search-normal'/>
                </div>
                <input
                    type="text"
                    ref={inputRef}
                    className="pr-12  text-dark-blue-200 placeholder:text-gray-200   block   text-12 outline-none w-full"
                    placeholder={placeholder}
                    onChange={changeInputValue}
                    onKeyDown={handleKeyDown}
                />
                {
                    cancelIsShow && (
                        <Icon
                            iconName='forbidden-3'
                            onClick={onCancelBtnClick}
                              className={'my-auto ml-[6px] cursor-pointer'}/>
                    )
                }

                <button type={"button"}
                        className="px-3.5 text-dark-blue-200 text-12 border-r-2 border-gray mt-2.5 mb-2.5 "
                        onClick={event => onSearchBtnClick(inputValue)}>بگرد
                </button>
            </div>
        </div>

    );
};
export default TableSearchBox
